import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { isPathMatch } from '@/utils/validate'
import { isRelogin } from '@/utils/request'

NProgress.configure({ showSpinner: false })

// 子目录 base，例如 /admin
const BASE = process.env.VUE_APP_BASE_PATH || ''

const whiteList = [
  `${BASE}/login`,
  `${BASE}/register`
]

const isWhiteList = (path) => {
  return whiteList.some(pattern => isPathMatch(pattern, path))
}

router.beforeEach((to, from, next) => {
  NProgress.start()

  if (getToken()) {
    to.meta.title && store.dispatch('settings/setTitle', to.meta.title)

    // 已登录还访问登录页 → 跳首页
    if (to.path === `${BASE}/login`) {
      next({ path: BASE || '/' })
      NProgress.done()
    } else if (isWhiteList(to.path)) {
      next()
    } else {
      if (store.getters.roles.length === 0) {
        isRelogin.show = true
        store.dispatch('GetInfo').then(() => {
          isRelogin.show = false
          store.dispatch('GenerateRoutes').then(accessRoutes => {
            router.addRoutes(accessRoutes)
            next({ ...to, replace: true })
          })
        }).catch(err => {
          store.dispatch('LogOut').then(() => {
            Message.error(err)
            next({ path: `${BASE}/login` })
          })
        })
      } else {
        next()
      }
    }
  } else {
    // 未登录
    if (isWhiteList(to.path)) {
      next()
    }else if (to.path.startsWith(`${BASE}/register`)) {
      // 访问注册页 → 跳注册
      next(`${BASE}/register?redirect=${encodeURIComponent(to.fullPath)}`)
      NProgress.done()
    } else {
      // 其它全部跳登录
      next(
        `${BASE}/login?redirect=${encodeURIComponent(to.fullPath)}`
      )
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
